import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment.local';
import { IVideoApi } from './interfaces/video-abstract.api';
import { ApiHttpResponse, VideoSection } from '@kinomap-dev/ng-ui-lib';

@Injectable({
  providedIn: 'root',
})
export class ExternalVideoApi implements IVideoApi {
  private readonly http: HttpClient = inject(HttpClient);

  getVideos(
    page: number,
    limit: number,
    userId: number,
    params: HttpParams = new HttpParams()
  ): Observable<ApiHttpResponse<VideoSection[]>> {
    params = params
      .append('page', page)
      .append('limit', limit)
      .append('withoutCoaching', true);
    const url: string = environment.api.externalUser.videos.replace(
      '{userId}',
      '' + userId
    );
    return this.http.get<ApiHttpResponse<VideoSection[]>>(url, { params });
  }
}
